import { useUserContext } from "../contexts";
import { Login as LoginComponent } from "../components/Login";

export function Login() {
  const { handleLogInAttempt } = useUserContext();

  return <LoginComponent handleLogInAttempt={handleLogInAttempt} />;
}
